
export enum localStorageFilterType {
  HOW_FAR_WE_GO_BACK_DROPDOWN = 'howFarWeGoBack',
  FILTER_DROPDOWN = 'filter',
  SORT_DASHBOARD_DROPDOWN = 'sortDashboard'
}

